import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, onlyChangedModel, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import Avatar from './Avatar';

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.formState = FormState.create(this);
    this.state = this.formState.injectModel(props.form);

    this.initials = this.formState.get('initials');
  }

  setAvatar = (base64) => {
    const context = this.formState.createUnitOfWork();

    context.set('avatar', base64);
    context.updateFormState();
  };

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork();
    context.set(name, value).validate();

    context.updateFormState();
  };

  onSubmit = (e) => {
    e.preventDefault();

    const context = this.formState.createUnitOfWork();

    const password = context.getFieldState('password').getValue();
    const passwordRepeat = context.getFieldState('passwordRepeat').getValue();

    if (password === '' && passwordRepeat === '') {
      context.set('password', '')
        .set('passwordRepeat', '')
        .validate();

      context.updateFormState();
    }

    const model = context.createModel();

    if (model) {
      const { onSubmit } = this.props;
      onSubmit(e, onlyChangedModel(context.formState, model));
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const { onCancel, serverErrors } = this.props;

    const avatar = this.formState.get('avatar');
    const errors = populateFormErrors(this.formState, serverErrors);

    return (
      <FormStateForm formState={this.formState} onSubmit={this.onSubmit} className="c-popup profile-edit">
        <div className="c-inactive-bg__stop">
          <div className="c-popup__head">
            <div className="c-popup__close">
              <a href="#" onClick={onCancel}>
                <i className="icon-close" />
              </a>
            </div>
          </div>

          <fieldset>
            <div className="c-popup__body">
              <header>
                <h1 className="campaign-edit__header">Úprava vášho konta</h1>
              </header>

              <div>
                <div className="l-row l-no-padding">
                  <label className="c-input__wrapper l-1-2 l-no-l-padding">
                    <span className="c-input__label">E-mailová adresa - nie je možné zmeniť</span>
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.email }
                    )}>
                      <WiredInput
                        disabled="true"
                        name="email"
                        type="email"
                        className="c-input"
                        onChange={this.onInputChange}
                        validator={v => v
                          .required().msg('profileEditor.form.errors.email.required')
                          .email().msg('profileEditor.form.errors.email.email')
                        }
                      />
                    </span>
                    <ValidationMessage msg={errors.email} />
                  </label>
                </div>

                <div className="l-row l-no-padding">
                  <label className="c-input__wrapper l-1-2 l-no-l-padding">
                    <span className="c-input__label">Meno</span>
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.firstName }
                    )}>
                      <WiredInput
                        name="firstName"
                        className="c-input"
                        onChange={this.onInputChange}
                        validator={v => v.required().msg('Vyzva sa potrebuje nejak volat')}
                      />
                    </span>
                    <ValidationMessage msg={errors.name} />
                  </label>

                  <label className="c-input__wrapper l-1-2 l-no-r-padding">
                    <span className="c-input__label">Priezvisko</span>
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.lastName }
                    )}>
                      <WiredInput
                        name="lastName"
                        className="c-input"
                        onChange={this.onInputChange}
                        validator={v => v
                          .required().msg('Nevyplnili ste cielovu sumu')
                        }
                      />
                    </span>
                    <ValidationMessage msg={errors.lastName} />
                  </label>
                </div>

                <div className="l-row l-no-padding">
                  <label className="c-input__wrapper l-1-2 l-no-l-padding">
                    <span className="c-input__label">Heslo &mdash; vyplňte iba ak chcete heslo meniť</span>
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.password }
                    )}>
                      <WiredInput
                        name="password"
                        className="c-input"
                        type="password"
                        revalidateOnSubmit
                        validator={(v, context) => {
                          const passwordOld = context.getFieldState('passwordOld').getValue();
                          const passwordRepeat = context.getFieldState('passwordRepeat').getValue();

                          return (passwordOld || passwordRepeat)
                            ? v.required().msg('Zadajte heslo')
                               .minLength(window.DRJM.config.minimalPasswordLength).msg('Vaše heslo musí mať aspoň osem znakov')
                            : v;
                        }}
                        onChange={this.onInputChange}
                      />
                    </span>
                    <ValidationMessage msg={errors.password} />
                  </label>

                  <label className="c-input__wrapper l-1-2 l-no-r-padding">
                    <span className="c-input__label">Heslo ešte raz</span>
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.passwordRepeat }
                    )}>
                      <WiredInput
                        name="passwordRepeat"
                        className="c-input"
                        type="password"
                        revalidateOnSubmit
                        validator={(v, context) => {
                          const password = context.getFieldState('password').getValue();

                          return password
                            ? v.required().msg('Zadajte heslo')
                               .minLength(window.DRJM.config.minimalPasswordLength).msg('Vaše heslo musí mať aspoň osem znakov')
                               .equals(password).msg('Hesla sa nezhoduju')
                            : v;
                        }}
                        onChange={this.onInputChange}
                      />
                    </span>
                    <ValidationMessage msg={errors.passwordRepeat} />
                  </label>
                </div>

                <div className="l-row l-no-padding">
                  <div className="l-2-3 l-no-l-padding">
                    <Avatar
                      name="avatar"
                      setAvatar={this.setAvatar}
                      avatar={avatar}
                      initials={this.initials}
                    />
                  </div>
                </div>

                <div className="expander" />
                <div className="expander--1-2" />

                <div className="campaign-edit__bottom-buttons">
                  <button type="submit" className="campaign-edit__button campaign-edit__button--submit c-button">
                    <span className="c-button__content">Uložiť zmeny</span>
                  </button>

                  <button
                    type="button"
                    className="campaign-edit__button campaign-edit__button--cancel c-button"
                    onClick={onCancel}
                  >
                    <span className="c-button__content">Zrušiť</span>
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </FormStateForm>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/profileEditor/Form.js